import { render, staticRenderFns } from "./BatidasRemotasPage.vue?vue&type=template&id=68b0dec2"
import script from "./BatidasRemotasPage.vue?vue&type=script&lang=js"
export * from "./BatidasRemotasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports